import {
  IOfferingRes,
  IQuoteItemReqSchema,
  SelectedProductsWithinOfferingForm,
} from '@monetize/types/app';
import { MCenterModal } from '../../../../../../components/Monetize';
import { ManageProductsForm } from './ManageProductsForm';

interface ManageProductsModalProps {
  offering: IOfferingRes;
  quoteItems: IQuoteItemReqSchema[];
  onSave: (
    selectedProducts: SelectedProductsWithinOfferingForm,
  ) => Promise<void>;
  onClose: () => void;
  quoteOffering: any;
  disableOneTimeProducts?: boolean;
}

export const ManageProductsModal = ({
  offering,
  quoteItems,
  quoteOffering,
  onSave,
  onClose,
  disableOneTimeProducts,
}: ManageProductsModalProps) => {
  if (quoteItems && !quoteItems?.length) {
    return null;
  }

  return (
    <MCenterModal
      isOpen
      modalTitle="Select Products for Offering"
      size="lg"
      modalHeaderProps={{ display: 'flex', alignItems: 'center' }}
      onClose={onClose}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      modalBodyProps={{
        overflow: 'none',
        padding: 0,
      }}
    >
      <ManageProductsForm
        onClose={onClose}
        offering={offering}
        quoteOffering={quoteOffering}
        updateOfferingItems={onSave}
        setProductsLoading={() => {}}
        isProductsLoading={false}
        disableOneTimeProducts={disableOneTimeProducts}
      />
    </MCenterModal>
  );
};
